// src/price/index.ts
var formatPrice = (price, maximumFractionDigits = 2) => {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits
  }).format(+price);
};
var addVatToPrice = (price, vat) => {
  const saveVat = vat == null || Number.isNaN(Number(vat)) ? 15 : Number(vat);
  const vatPercentage = saveVat / 100;
  const vatValue = 1 + vatPercentage;
  const validPrice = Number(price) || 0;
  return validPrice * vatValue;
};
var calculateDiscountPercentage = (originalPrice, price) => {
  if (!Number.isFinite(originalPrice) || !Number.isFinite(price) || originalPrice <= 0 || price < 0 || price >= originalPrice) {
    return "0";
  }
  return (Math.abs(originalPrice - price) / originalPrice * 100).toFixed(0);
};
var indianToArabicNumbers = (value) => {
  const arabicToEnglishMap = {
    "\u0660": "0",
    "\u0661": "1",
    "\u0662": "2",
    "\u0663": "3",
    "\u0664": "4",
    "\u0665": "5",
    "\u0666": "6",
    "\u0667": "7",
    "\u0668": "8",
    "\u0669": "9",
    "\u066B": ".",
    "\u2212": "-"
  };
  return value.split("").map((char) => arabicToEnglishMap[char] || char).join("");
};

export {
  formatPrice,
  addVatToPrice,
  calculateDiscountPercentage,
  indianToArabicNumbers
};
//# sourceMappingURL=chunk-XSXAQCSC.mjs.map